import type { FC } from 'react';
import { Navigate, Route } from 'react-router';
import { useOptionalStorageServiceRoot } from 'src/apis/storage/use-storage-service-root';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { StorageLocationsRoot } from 'src/pages/storage/locations';
import { StorageOfferCards } from 'src/pages/storage/offer-cards';
import { StorageOffers } from 'src/pages/storage/offers';
import { StorageOffersNewRoot } from 'src/pages/storage/offers-new';

export const StorageRoot: FC = () => {
  const storageServiceRoot = useOptionalStorageServiceRoot();
  if (!storageServiceRoot.loaded) {
    return <PageSpinner />;
  }

  return (
    <RootRoutes>
      <Route
        path="/storage"
        element={
          <Navigate
            to={
              storageServiceRoot.response?.data._links.getSsoOfferCards
                ? '/storage/offer-cards'
                : '/storage/offers'
            }
            replace
          />
        }
      />
      <Route path="/storage/offer-cards" element={<StorageOfferCards />} />
      <Route path="/storage/offers" element={<StorageOffers />} />
      <Route path="/storage/locations/*" element={<StorageLocationsRoot />} />

      {/* Storage Service offers */}
      <Route path="/storage/offers-new/*" element={<StorageOffersNewRoot />} />

      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
